// Utils
import { decodeJWT } from "./utils"

// Constants
import { UserIdentity } from "~constants/application"
import { Authorities } from "~shapes/auth"

export const extractUserIdentity = (token: string): UserIdentity => {
  const jwt = decodeJWT(token)

  if (!jwt) throw new Error("No JWT")

  const { payload } = jwt

  return {
    id: payload.infoUrl.replace(/\/$/, "").split("/").pop(),
    name: payload.name,
    infoUrl: payload.infoUrl,
    userName: payload.user_name,
    authorities: hydrateAuthorities(payload.authorities),
  }
}

const hydrateAuthorities = (authorities: string[]) => {
  const ROLE_NAMESPACE = "ROLE_"
  const hydratedResult: Authorities = {
    roles: [],
    permissions: [],
  }

  if (authorities.length === 0) {
    return hydratedResult
  }

  const roles: string[] = authorities.filter((auth: string) => {
    if (auth.startsWith(ROLE_NAMESPACE)) return auth
    else hydratedResult.permissions.push(auth)
  })
  hydratedResult.roles = roles

  return hydratedResult
}

export const getInitials = name => {
  let initials = name.split(" ")

  if (initials.length > 1) {
    initials = initials.shift().charAt(0) + initials.pop().charAt(0)
  } else {
    initials = name.substring(0, 2)
  }

  return initials.toUpperCase()
}
